<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div
            class="Polaris-Box Polaris-Box--printHidden"
            v-if="notificationConfig.abandonedCartNotification"
          >
            <button
              class="Polaris-Button"
              type="button"
              v-if="notificationConfig.abandonedCartNotification.isEnabled"
              @click="updateNotificationConfig(false)"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Deactivate</span>
              </span>
            </button>
            <button
              class="Polaris-Button Polaris-Button--primary"
              type="button"
              v-if="!notificationConfig.abandonedCartNotification.isEnabled"
              @click="updateNotificationConfig(true)"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Activate</span>
              </span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <router-view></router-view>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../../components/Common/Page";

export default {
  name: "WelcomeNotification",

  data() {
    return {
      pageTitle: "Abandoned Cart Automation",
      isLoading: false,
      currentCustomerPhoneNumber: null,
      notificationConfig: {}
    };
  },
  components: {
    Page
  },
  computed: {
    config() {
      return this.$store.getters.getConfig;
    }
  },
  created() {
    this.$store.dispatch("getConfig");
    this.getAutomationConfig();
    this.updateOnboadingFlag();
  },
  mounted() {},
  methods: {
    async getAutomationConfig() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.notificationConfig = response.config;
        this.isLoading = false;
      });
    },
    updateNotificationConfig(isEnabled) {
      this.$store
        .dispatch("updateAutomationConfig", {
          requestParams: {
            notificationConfig: {
              ...this.notificationConfig,
              abandonedCartNotification: {
                ...this.notificationConfig.abandonedCartNotification,
                isEnabled
              }
            }
          }
        })
        .then(response => {
          this.notificationConfig = response.config;
          this.$store.dispatch("showNotification", {
            text: "Settings Updated"
          });
        });
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isAutomatedAbandonedVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
